import React, { useImperativeHandle } from "react"
import { RouterProvider } from "react-router-dom"
import MasterProvider from "@/components/provider"
import GlobalStyles from "@/styles/GlobalStyles"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import routes from "@/routes"
import { App as AntDApp } from "antd"
import { notificationRef } from "./core/refs"

function MyApp() {
    const { notification } = AntDApp.useApp()

    useImperativeHandle(notificationRef, () => notification)

    return (
        <>
            <GlobalStyles />
            <RouterProvider router={routes} />
            <ReactQueryDevtools />
        </>
    )
}

export default function SchedulerApp() {
    return (
        <MasterProvider>
            <MyApp />
        </MasterProvider>
    )
}
